import './index.css'
import App from './App'
import React from 'react'
import ReactDOM from 'react-dom'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
   <App />,
  document.getElementById('root')
)

reportWebVitals()
